import { useCallback, useEffect, useRef, useState } from 'react';

export type MetricParam = { [key: string]: MetricParam | string };
const STATS_EVENT_TYPE = 'services_mos';
const STATS_COUNTER_ID = 14112952;

export const useSpatzLoader = () => {
  const spatzTimer = useRef<number | undefined>(undefined);

  const initSpatz = useCallback(() => {
    if (!window.Spatz) {
      return false;
    }
    window.Spatz.addYaCounter(
      STATS_COUNTER_ID,
      {
        clickmap: false,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: false,
        trackHash: true,
      },
      {
        initOnly: true,
      }
    );
    return true;
  }, []);

  const tryInitSpatz = useCallback(() => {
    if (initSpatz()) {
      return;
    }
    clearTimeout(spatzTimer.current);
    spatzTimer.current = window.setTimeout(tryInitSpatz, 2500);
  }, [initSpatz]);

  useEffect(() => {
    tryInitSpatz();
    return () => {
      clearTimeout(spatzTimer.current);
    };
  }, [tryInitSpatz]);
};

export const appendMetricData = (path: MetricParam, data?: MetricParam) => {
  if (Object.keys(path).length === 0) {
    return data || {};
  }

  if (!data || Object.keys(data).length === 0) {
    return path;
  }

  const result: MetricParam = {};

  // Копируем исходное дерево и ищем место подстановки значения
  let stop = false;
  let valueNode = { ...path };
  let resultNode = result;
  while (!stop) {
    const key = Object.keys(valueNode)[0];
    const value = valueNode[key];
    if (key && Object.keys(value).length === 0) {
      // подстановка для случая {...{ name: {} }} -> {...{ name: data}}
      resultNode[key] = data;
      stop = true;
    } else if (key && typeof value === 'string') {
      // подстановка для случая {...{ name: 'anotherName' }} -> {...{ name: { anotherName: data}}}
      resultNode[key] = { [value]: data };
      stop = true;
    } else if (typeof value !== 'string') {
      // копируем данные из path и спускаемся ниже
      valueNode = { ...value };
      resultNode[key] = valueNode;
      resultNode = valueNode;
    } else {
      // непонятно как здесь оказались, но на всякий случай
      stop = true;
    }
  }
  return result;
};

export const useSpatz = (path?: MetricParam) => {
  const [pathState] = useState<MetricParam>({ ...path });
  const sendSpatzStats = useCallback(
    (data: MetricParam = {}, appendToPath = true) => {
      let metricData: MetricParam = data;
      if (pathState && appendToPath) {
        metricData = appendMetricData({ ...pathState }, data);
      }
      if (window.Spatz) {
        window.Spatz.send({
          type: STATS_EVENT_TYPE,
          data: metricData,
        });
      }
    },
    [pathState]
  );

  return { sendSpatzStats };
};
